import React from 'react';
import styled from 'styled-components';
import { Flex } from './Flex';
import { Label, StyledLoadingText } from './Text';


const StyledGauge = styled(Flex).attrs({
    flex: 1,
})`
    border-radius: 8px;
`;

const StyledGaugeBar = styled(Flex).attrs(({ flex }) => ({
    flex: `1 1 ${flex}%`,
    height: "24px",
    align: "center",
    justify: "space-between",
    padding: { left: "10px", right: "10px" }
}))`
    background: ${({color}) => color};

    &:first-child {
        border-radius: 8px 0 0 8px;
    }

    &:last-child {
        border-radius: 0 8px 8px 0;
    }

    &:only-child {
        border-radius: 8px;
    }
`;

const Gauge = ({ bars=[], values, total, emptyText, loading, ...props }) => (
    <StyledGauge>
        {loading
        ? <StyledLoadingText height="24px" width="100%" radius="8px" />
        : total > 0
            ? bars.map(bar => {
                if (values[bar.key] > 0) {
                    let percent = Math.max(1, Math.round(100 * values[bar.key] / total));
                    return (<StyledGaugeBar {...bar} flex={percent}>
                        <Label bold lowercase color="#FFFFFF">{values[bar.key]}&nbsp;{bar.key}</Label>
                        <Label bold color="#FFFFFF">{percent}%</Label>
                    </StyledGaugeBar>)
                }
            })
            : <StyledGaugeBar flex={1} color="#f0f3fa">
                <Label bold>{emptyText}</Label>
            </StyledGaugeBar>
        }
    </StyledGauge>
);

export { Gauge };
